import React from 'react';
import AdmissionProcess from '../components/Addmission/AdmissionProcess';
import UniqueBanner from "../components/UniqueBanner";
import BannerImg from "../assets/Institute/Addmission-banner.jpeg";
import AdmissionForm from '../components/Addmission/AdmissionForm';


const NttCourse = () => {
  return (
    <>
    <UniqueBanner
  image={BannerImg}
  title="Teacher Teaching Admission"
  subtitle="Join NIECCE and shape your career in early childhood education"
/>
<AdmissionProcess />
<AdmissionForm />
    </>
  );
};

export default NttCourse;
